const LEAD_TYPES = {
    AD_SUBSCRIPTION_REQUEST: 'AD_SUBSCRIPTION_REQUEST',
    ACCOUNT_CREATION: 'ACCOUNT_CREATION',
    ALERT_ME_USEDCAR: 'ALERT_ME_USEDCAR',
    ASK_QUESTIONS: 'ASK_QUESTIONS',
    // BODY_MAINTENANCE: 'BODY_MAINTENANCE',
    BROCHURE_REQUEST: 'BROCHURE_REQUEST',
    BUILD_AND_PAY: 'BUILD_AND_PAY',
    CANADIAN_BLACK_BOOK: 'CANADIAN_BLACK_BOOK',
    CARPROOF_USEDCAR: 'CARPROOF_USEDCAR',
    CHECKOUT_CONFIRMATION_NEW: 'CHECKOUT_CONFIRMATION_NEW',
    CHECKOUT_CONFIRMATION_USED: 'CHECKOUT_CONFIRMATION_USED',
    CHECKOUT_DEPOSIT_NEW: 'CHECKOUT_DEPOSIT_NEW',
    CHECKOUT_DEPOSIT_USED: 'CHECKOUT_DEPOSIT_USED',
    CHECKOUT_FINANCING_NEW: 'CHECKOUT_FINANCING_NEW',
    CHECKOUT_FINANCING_USED: 'CHECKOUT_FINANCING_USED',
    COMPLAINT: 'COMPLAINT',
    CONTEST_COUPON: 'CONTEST_COUPON',
    CONTEST: 'CONTEST',
    COUPON: 'COUPON',
    CUSTOMER_REVIEW: 'CUSTOMER_REVIEW',
    EVALUATE_EXCHANGE_NEWCAR: 'EVALUATE_EXCHANGE_NEWCAR',
    EVALUATE_EXCHANGE_USEDCAR: 'EVALUATE_EXCHANGE_USEDCAR',
    EVENT: 'EVENT',
    EXCLUSIVE_SALE: 'EXCLUSIVE_SALE',
    EXTENDED_WARRANTY_REQUEST: 'EXTENDED_WARRANTY_REQUEST',
    FACEBOOK_CONNECT_NEW: 'FACEBOOK_CONNECT_NEW',
    FACEBOOK_CONNECT_USED: 'FACEBOOK_CONNECT_USED',
    FACEBOOK_CONNECTION: 'FACEBOOK_CONNECTION',
    FACEBOOK_CONTEST: 'FACEBOOK_CONTEST',
    FRIEND_REFERRAL: 'FRIEND_REFERRAL',
    GIFT_CARD: 'GIFT_CARD',
    INFO_REQUEST_NEW: 'INFO_REQUEST_NEW',
    INFO_REQUEST_SERVICE: 'INFO_REQUEST_SERVICE',
    INFO_REQUEST_USED: 'INFO_REQUEST_USED',
    INSURANCE_QUOTE: 'INSURANCE_QUOTE',
    // JOB_REQUEST: 'JOB_REQUEST',
    LEASE_TRANSFERT: 'LEASE_TRANSFERT',
    MAINTENANCE_REQUEST_NEW: 'MAINTENANCE_REQUEST_NEW',
    MEETING_NEWCAR: 'MEETING_NEWCAR',
    MEETING_USEDCAR: 'MEETING_USEDCAR',
    MEETING_WITH_SALES_NEW: 'MEETING_WITH_SALES_NEW',
    MEETING_WITH_SALES_USED: 'MEETING_WITH_SALES_USED',
    NEW_START_CREDIT: 'NEW_START_CREDIT',
    // NISSAN_PROMOTION: 'NISSAN_PROMOTION',
    ONLINE_REQUEST: 'ONLINE_REQUEST',
    // PARTS_ORDER: 'PARTS_ORDER',
    PRIVATE_SALE_USED: 'PRIVATE_SALE_USED',
    PRIVATE_SALE: 'PRIVATE_SALE',
    // QUICL_TIRE: 'QUICL_TIRE',
    QUOTE_FINANCING_NEWCAR: 'QUOTE_FINANCING_NEWCAR',
    QUOTE_FINANCING_USEDCAR: 'QUOTE_FINANCING_USEDCAR',
    QUOTE_REQUEST_NEWCAR: 'QUOTE_REQUEST_NEWCAR',
    QUOTE_REQUEST_USEDCAR: 'QUOTE_REQUEST_USEDCAR',
    REBATE_COUPON_NEW: 'REBATE_COUPON_NEW',
    REBATE_COUPON_SERVICE: 'REBATE_COUPON_SERVICE',
    REBATE_COUPON_USED: 'REBATE_COUPON_USED',
    // REFERRAL_TRINERGIE: 'REFERRAL_TRINERGIE',
    RENTAL: 'RENTAL',
    REWARD_ACCOUNT: 'REWARD_ACCOUNT',
    REWARD_CARD_REQUEST: 'REWARD_CARD_REQUEST',
    ROADTEST_NEWCAR_WALKIN: 'ROADTEST_NEWCAR_WALKIN',
    ROADTEST_NEWCAR: 'ROADTEST_NEWCAR',
    ROADTEST_USEDCAR: 'ROADTEST_USEDCAR',
    SERVICE_APPOINTMENT_CONFIRMATION: 'SERVICE_APPOINTMENT_CONFIRMATION',
    SERVICE_APPOINTMENT_UPDATE: 'SERVICE_APPOINTMENT_UPDATE',
    SHORTEN_SALE: 'SHORTEN_SALE',
    SHOWROOM: 'SHOWROOM',
    // SMS: 'SMS',
    SPECIAL_OFFER_NEW: 'SPECIAL_OFFER_NEW',
    SPECIAL_OFFER_SERVICE: 'SPECIAL_OFFER_SERVICE',
    SPECIAL_OFFER_USED: 'SPECIAL_OFFER_USED',
    SPECIAL_OFFER: 'SPECIAL_OFFER',
    SPONSORING_REQUEST: 'SPONSORING_REQUEST',
    SURPRISE_REBATE: 'SURPRISE_REBATE',
    USEDCAR_AVAILABLE: 'USEDCAR_AVAILABLE',
    YOUR_OPINION: 'YOUR_OPINION',
};

export default LEAD_TYPES;



// WEBPACK FOOTER //
// ./src/constants/leadTypes.js